<template>
  <nav
    class="px-6 flex items-center justify-between flex-wrap bg-white border-b-2 border-gray-300 h-20"
  >
    <div class="container mx-auto flex items-center">
      <router-link :to="{ path: '/' }" class="block">
        <img v-if="logo" :src="logo" :alt="websiteName" class="h-10" />
        <span class="font-semibold text-lg text-gray-800 py-6" v-else>{{
          websiteName
        }}</span>
      </router-link>
    </div>
    <template slot="end">
      <div label="Categories" class="is-hidden-desktop">
        <a
          @click="setSelectedCategory(null)"
          :active="selectedCategory === null"
        >
          All
        </a>
        <a
          v-for="(filter, index) in filters"
          :key="`filter-${index}`"
          @click="setSelectedCategory(filter)"
          :active="filter === selectedCategory"
        >
          {{ filter }}
        </a>
      </div>
    </template>
  </nav>
</template>

<script>
export default {
  name: "TheNavbar",

  data() {
    return {
      showMenu: false
    };
  },

  computed: {
    selectedCategory() {
      return this.$store.state.selectedCategory;
    },
    filters() {
      return this.$store.state.filters;
    },
    logo() {
      return this.$store.state.config.logo;
    },
    websiteName() {
      return this.$store.state.config.name;
    }
  },

  methods: {
    setSelectedCategory(category) {
      this.showMenu = false;
      this.$store.commit("setSelectedCategory", category);
    }
  }
};
</script>
